const getIcon = (name: string | number, type = 'solid', family = '') => (
  <i className={`fa-${type} fa-${String(name)} ${family} `}></i>
)

const iconsData = {
  task: () => getIcon('circle-check', 'regular'),
  checkbox: () => getIcon('square-check', 'regular'),
  bold: () => getIcon('bold'),
  italic: () => getIcon('italic'),
  underlined: () => getIcon('underline'),
  strikethrough: () => getIcon('strikethrough'),
  highlighted: () => getIcon('highlighter', 'regular', 'sharp'),
  hashtag: () => getIcon('hashtag'),
  code: () => getIcon('code-simple'),
  link: () => getIcon('link'),
  getIcon,
  bullet: () => getIcon('list-ul'),
  heading: () => getIcon('heading'),
  numList: () => getIcon('list-ol'),
  left: () => getIcon('align-left'),
  center: () => getIcon('align-center'),
  right: () => getIcon('align-right'),
  justify: () => getIcon('align-justify'),
  fontCase: () => getIcon('font-case'),
  flagged: () => getIcon('flag', 'regular', 'sharp'),
  schedule: () => getIcon('calendar-arrow-up', 'light'),
  today: () => (
    <i
      className={`fa-regular fa-star text-orange-500 dark:text-orange-400`}
    ></i>
  ),
  tomorrow: () => (
    <i
      className={`fa-solid fa-arrow-right-to-line text-blue-500 dark:text-blue-400`}
    ></i>
  ),
}
export default iconsData
